export { AtnDsInitialStateComponent as Component } from './initial-state.component'
